import { Loader } from '@googlemaps/js-api-loader'
import config from './config'

const loader = new Loader({
  apiKey: config.GOOGLE_MAPS_API_KEY,
  version: 'weekly',
  libraries: ['places']
})

let google = null

async function getGoogle () {
  if (google) return google

  await loader.load()
  google = window.google
  return google
}

export default getGoogle
